<template>
  <div class="accordion-faq-item">
    <input type = "checkbox" :id = "origin + index" :checked = "!itemHide" @click = "emitShowFaq(origin, index)">
    <label
      class = "accordion-faq-item-title"
      :for = "origin + index"
    >
      <aside class="accordion-faq-item-title-icon">
        <i class="us us-code us-3x us-fw" aria-hidden="true"/>
        <!--a class="accordion-faq-item-title-name" :href="'#' + origin + index">{{ question }}</a-->
        {{ question }}
      </aside>
    </label>
    <div
      :id = "origin + '-' + index"
      class = "accordion-faq-item-content"
      data-tab-content
    >
      <ul>
        <li
          v-for="(item, index) in response"
          :key = index
        >
            {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "faqItem",
  props: {
    index: {
      type: Number,
      required: true,
    },
    origin: {
      type: String,
      required: true,
    },
    question: {
      type: String,
    },
    response: {
      type: Array,
      required: true,
    },
    itemHide: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    emitShowFaq(origin, index) {
      this.$emit('show-faq', origin, index)
    },
  },
}
</script>

<style lang="scss">
@import "../../utilities/variables";

input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.accordion-faq-item {
  width: 100%;
  color: $text-color;
  overflow: hidden;
  &-title {
    display: flex;
    place-items: start center;
    justify-content: space-between;
    padding: 1em;
    background-color: $accordion-background-color;
    font-weight: bold;
    cursor: pointer;
    /* Icon */
    &:hover {
      background-color: darken($accordion-background-color, 10%);
    }
    &::after {
      content: "\276F";
      width: 1em;
      height: 1em;
      text-align: center;
      transition: all .35s;
      order: 2;
    }
    &-icon {
      flex: 1 auto;
      order: -1;
    }
    &-name {
      flex: 1 auto;
      order: 0;
    }
  }
  &-content {
    max-height: 0;
    padding: 0 1em;
    color: $text-color;
    background-color: $accordion-background-color;
    transition: all .35s;
    display:block;
  }
}

input:checked {
  + .accordion-faq-item {
    &-title {
      background-color: darken($accordion-background-color, 5%);
      &:hover {
        background-color: darken($accordion-background-color, 10%);
      }
      &::after {
        transform: rotate(90deg);
      }
    }
  }
  ~ .accordion-faq-item-content {
    max-height: 100vh;
    padding: 1em;
  }
}
</style>
